module.exports = __webpack_public_path__ + "static/media/quiz-09.857cf1d6.jpg";